import styled from 'styled-components';

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const EmojiOptionContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EmojiIcon = styled.span`
  font-size: 20px;
`;

export {
  TitleContainer,
  EmojiOptionContainer,
  EmojiIcon,
};
